import { supabase } from './client';

export const getAuthenticatedClient = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  // if (!session) {
  //   throw new Error('No authenticated session');
  // }

  return supabase;
};
